// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__X0NKW","title":"Card_title__8kAFh","titleRow":"Card_titleRow__gPCPK","dots":"Card_dots__AWCqA","dot":"Card_dot__FJ3sI","data":"Card_data__wTwVp"};